import React from "react";
import SkillCard from "./SkillCard";

const Backend = () => {
  return (
    <div className="skills__content">
      <h3 className="skills__title">Backend Developer</h3>
      <div className="skills__box">
        <div className="skills__group">
          <SkillCard name="Node JS" level="Basic" />
          <SkillCard name="Firebase" level="Intermediate" />
          <SkillCard name="Python" level="Intermediate" />
        </div>
        <div className="skills__group">
          <SkillCard name="MongoDB" level="Intermediate" />
          <SkillCard name="Mongoose" level="Intermediate" />
          {/* <SkillCard name="SQL" level="Basic" /> */}
        </div>
      </div>
    </div>
  );
};

export default Backend;
